<template>
    <div>
        <b-card-header>
            <span class="h5"> Cronograma Desembolso </span>
        </b-card-header>
            <app-tabela
                idTabela="tblCronogramaDesembolso"
                :itens="cronogramasDesembolsos"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="botoes">
                    <b-button-group class="float-right">
                        <btn-inserir-cronograma-desembolso
                            v-if="$temAcessoView('CONV-DES-01')"
                            :convenio="convenio"
                            @atualizarLista="atualizarLista()">
                        </btn-inserir-cronograma-desembolso>
                    </b-button-group>
                </template>
                <template slot="nuValorDesembolso" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.nuValorDesembolso | currency }}
                    </p>
                </template>
                <template slot="dtMesAno" slot-scope="data">
                    <p class="text-left m-0">
                        {{ data.dtMesAno ? $moment(data.dtMesAno).format('MM/YYYY') : '' }}
                    </p>
                </template>
                <template slot="acoes" slot-scope="data">
                    <btn-atualizar-cronograma-desembolso
                        class="text-danger float-left mr-1"
                        v-if="$temAcessoView('CONV-DES-02')"
                        :convenio="convenio"
                        :cronogramaDesembolso="data"
                        @atualizarLista="atualizarLista()">
                    </btn-atualizar-cronograma-desembolso>
                    <btn-excluir-cronograma-desembolso
                        class="text-danger float-left mr-1"
                        v-if="$temAcessoView('CONV-DES-02')"
                        :convenio="convenio"
                        :cronogramaDesembolso="data"
                        @atualizarLista="atualizarLista()"
                    ></btn-excluir-cronograma-desembolso>


                    <!-- Btn-Liberacao-Recursos
                        :parentData="data"
                        :desativarBotao="false"
                        class="mr-2"
                        v-if="$temAcessoView('CONV-00')"
                        @atualizarLista="atualizarLista()"
                    >
                    </Btn-Liberacao-Recursos-->
                </template>
            </app-tabela>

    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import BtnLiberacaoRecursos from "../cadastro/BtnLiberacaoRecursos.vue"
import BtnInserirCronogramaDesembolso from '../cadastro/cronogramaDesembolso/BtnInserirCronogramaDesembolso.vue'
import BtnExcluirCronogramaDesembolso from '../cadastro/cronogramaDesembolso/BtnExcluirCronogramaDesembolso.vue'
import BtnAtualizarCronogramaDesembolso from '../cadastro/cronogramaDesembolso/BtnAtualizarCronogramaDesembolso'

export default {
    props: {
        convenio: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        BtnInserirCronogramaDesembolso,
        BtnLiberacaoRecursos,
        BtnAtualizarCronogramaDesembolso,
        BtnExcluirCronogramaDesembolso,
    },

    data() {
        return {
            cronogramasDesembolsos: [],
            itensSelecionados: [],
            erros: [],
            campos: [
                {
                    key: 'vcDescricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuParcela',
                    label: 'Parcela',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dtMesAno',
                    label: 'Mês\\Ano',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuValorDesembolso',
                    label: 'Valor',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {

        atualizarLista(){
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterPorId(this.convenio.idConvenio)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.cronogramasDesembolsos = response.data.cronogramasDesembolsos
                        this.$emit('atualizarDadosConvenio')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

    },

    computed: {
        mostrarTabela() {
            return false
        },
    },

    watch:{
        convenio(){
            if(this.convenio){
                this.cronogramasDesembolsos = this.convenio.cronogramasDesembolsos
            }
        }
    },
}
</script>
